import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { AuthGuard } from '~/auth/guards/auth.guard';
import { OrganizerSharedPageOverviewComponent } from '~/organizer/shared/components/pages/overview/overview.component';
import { OrganizerSharedGetActivityByQueryIdGuard } from '~/organizer/shared/guards/get-activity-by-query-id/get-activity-by-query-id.guard';
import { OrganizerSharedGetOrganizationByQueryIdGuard } from '~/organizer/shared/guards/get-organization-by-query-id/get-organization-by-query-id.guard';
import { OrganizerSharedGetOrganizationFromAuthUserGuard } from '~/organizer/shared/guards/get-organization-from-auth-user/get-organization-from-auth-user.guard';
import { OrganizerSharedHasActivityGuard } from '~/organizer/shared/guards/has-activity/has-activity.guard';
import { OrganizerSharedHasOrganizationGuard } from '~/organizer/shared/guards/has-organization/has-organization.guard';
import { OrganizerActivitySharingPageShareComponent } from './components/pages/share/share.component';
import { OrganizerActivitySharingPageSuccessComponent } from './components/pages/success/success.component';

const routes: Routes = [
  {
    path: 'organizer.activity-sharing.steps-3',
    component: OrganizerSharedPageOverviewComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-sharing.share',
    component: OrganizerActivitySharingPageShareComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
  {
    path: 'organizer.activity-sharing.success',
    component: OrganizerActivitySharingPageSuccessComponent,
    canActivate: [
      AuthGuard,
      OrganizerSharedGetOrganizationByQueryIdGuard,
      OrganizerSharedGetOrganizationFromAuthUserGuard,
      OrganizerSharedHasOrganizationGuard,
      OrganizerSharedGetActivityByQueryIdGuard,
      OrganizerSharedHasActivityGuard,
    ],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class OrganizerActivitySharingRoutingModule {}
